import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from './dashboardSlice/dashboardSlice';
import AuthReducer from './authSlice/authSlice';
import startCourseReducer from './startCourseSlice/startCourseSlice';

export const store = configureStore({
  reducer: {
    dashboardState: dashboardReducer,
    authState: AuthReducer,
    startCourseState: startCourseReducer
  },
  devTools: true,
});